import { isEmpty } from '@jjj/components';
import actions from './actions';
import { t } from '../../../i18n';
import { keyBy } from '../../../helpers/core';
import { createReducer } from '../../../helpers/reducer';

function validate(attr, value) {
  let error = '';

  if (attr === 'text') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.editFeedback.form.text_label') });
    }
  }

  return error;
}

const initialData = {
  text: {
    value: '',
    error: validate('text', ''),
    name: 'text',
    touched: false,
  },
};

const initState = {
  editForm: { ...initialData },
  feedbacks: null,
  reports: null,
  isEditModalShown: false,
  isAddModalShown: false,
};

function onLoadSuccess(state, { payload }) {
  const { data } = payload.data;
  const feedbacks = data.worker;
  const reports = data.client;

  return {
    ...state,
    feedbacks,
    reports,
  };
}

function onClearStore(state) {
  return { ...initState, feedbacks: state.feedbacks, reports: state.reports };
}

function onShowEditModal(state, { payload }) {
  const { item, reasonType, usableBy } = payload;

  const editForm = {
    text: {
      value: item.text,
      error: validate('text', item.text),
      name: 'text',
      touched: false,
    },
  };

  editForm.reasonType = reasonType;
  editForm.usableBy = usableBy;
  editForm.item = item;

  return {
    ...state,
    isEditModalShown: true,
    editForm,
  };
}

function onShowAddModal(state, { payload }) {
  const { item, reasonType, usableBy } = payload;

  const editForm = {
    text: {
      value: item?.text,
      error: validate('text', item?.text),
      name: 'text',
      touched: false,
    },
  };

  editForm.reasonType = reasonType;
  editForm.usableBy = usableBy;

  return {
    ...state,
    isAddModalShown: true,
    editForm,
  };
}

function onCloseModal(state) {
  return {
    ...state,
    isEditModalShown: false,
    isAddModalShown: false,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.SHOW_ADD_MODAL]: onShowAddModal,
  [actions.SHOW_EDIT_MODAL]: onShowEditModal,
  [actions.CLOSE_MODAL]: onCloseModal,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.TOUCH]: onTouch,
});
